"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.VIRTUAL_TRY_ON_PDP_CONTAINER = void 0;
const VIRTUAL_TRY_ON_PDP_CONTAINER = exports.VIRTUAL_TRY_ON_PDP_CONTAINER = 'virtual-try-on-pdp-container';